import { createAxiosClient } from "@/shared/axios/axios";
import { handleAxiosError } from "@/shared/helper/handleAxiosError.helper";
import type { FBSContainerListResponse } from "@/shared/generated/ExpHubApi";

export const getContainers = async ({
  userId,
  customerId,
}: {
  userId: string;
  customerId: string;
}) => {
  try {
    const client = await createAxiosClient();
    const response = await client.get(
      `/users/${userId}/accounts/${customerId}/fbs/containers`,
    );
    return response.data.containers as Array<
      FBSContainerListResponse["containers"][number]
    >;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
